const ACTIONS = {
    SET_OPPORTUNITY: 'SET_OPPORTUNITY',
    SET_OPPORTUNITY_BYID: 'SET_OPPORTUNITY_BYID',
    OPPORTUNITY_NOTFOUND: 'OPPORTUNITY_NOTFOUND',
};
const INITIAL_STATE = {
    opportunities: [],
    opportunity: {},
    opportunityNotFound: false,
};
export function OpportunityReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.SET_OPPORTUNITY:
            return {
                ...state,
                opportunities: action.opportunities,
                opportunityNotFound: false,
            };
        case ACTIONS.SET_OPPORTUNITY_BYID:
            return {
                ...state,
                opportunity: action.opportunity,
                opportunityNotFound: false,
            };
        case ACTIONS.OPPORTUNITY_NOTFOUND:
            return {
                ...state,
                opportunityNotFound: true,
            };
        default:
            return state;
    }
}
